/* eslint-disable react/jsx-curly-brace-presence */
/* eslint-disable prettier/prettier */
/** @jsx jsx */

import Helmet from 'react-helmet';
import { jsx, useColorMode } from 'theme-ui';

const base = {
  title: `Functionary Labs | Product Design Studio in Bangalore`,
  url: `https://functionary.co`,
  description: `Functionary Labs | Product Design Studio in Bangalore`,
  image: `https://drive.google.com/file/d/1aJ2V6eLSSOnHluqP_veuUH-O4iYGpObk/view`,
  author: `@functionarylabs`,
};

export interface HaloProps {
  title: string;
  url: string;
  description: string;
  image: string;
  author: any;
}
function Halo({ title, image, url, description, author }: HaloProps) {
  // const Halo: FC<HaloProps> = ({
  //   title = base.title,
  //   url = base.url,
  //   description = base.description,
  //   image = base.image,
  //   author = base.author,
  // }) => {
  const [colorMode] = useColorMode();

  return (
    <Helmet>
      <title>{`${title}${title === base.title ? `` : ` | Functionary`}`}</title>
      <link rel="canonical" href={url} />
      <meta name="title" content={description} />
      <meta
        property="og:url"
        content="https://functionary-website.vercel.app/"
      />
      {/* <meta property="og:image" content={`../../home.png`} /> */}
      <meta
        data-react-helmet="true"
        property="og:image"
        itemProp="image"
        data-type="default_53468"
        content={image}
      />
      <meta
        name="description"
        property="og:image"
        content="Functionary Labs is a multidisciplinary product design studio."
      />
      <meta
        name="theme-color"
        content={colorMode === `dark` ? `#000` : `#dfeff3`}
      />
      <meta name="application-name" content="Functionary" />
      <meta name="apple-mobile-web-app-title" content="Functionary" />
      <meta
        name="theme-color"
        content={colorMode === `dark` ? `#000` : `#dfeff3`}
      />
      <link rel="icon" href="favicon.svg" />
      <link rel="mask-icon" href="favicon.svg" color="#000000" />
      <link rel="apple-touch-icon" href="apple-touch-icon.png" />
      <link rel="manifest" href="manifest.json" />
      <meta property="og:url" content={url} />
      <meta property="og:site_name" content={author} />
      <meta property="og:type" content="article" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="628" />
      <meta
        property="og:image:alt"
        content={`"Functionary" displayed in black on a light blue background`}
      />
      {/* <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:creator" content={author} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      <meta name="twitter:site" content={author} />
      <meta name="twitter:creator" content={author} /> */}
      {/* <!-- Twitter --> */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content="https://www.functionary.co/" />
      <meta
        property="twitter:title"
        content="Functionary Labs | Product Design Studio in Bangalore"
      />
      <meta
        property="twitter:description"
        content="Functionary Labs is a multidisciplinary product design studio."
      />
      <meta property="twitter:image" content={image} />

      {/* <!-- Open Graph / Facebook --> */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://www.functionary.co/" />
      <meta
        property="og:title"
        content="Functionary Labs | Product Design studio in Bangalore"
      />
      <meta
        property="og:description"
        content="Functionary Labs is a multidisciplinary product design studio."
      />
      <meta property="og:image" content={image} />
    </Helmet>
  );
}

export default Halo;
